import { Box } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import NavSearchInput from "~/features/navbar/NavSearchInput";
import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import {
  selectRow,
  setIsPutawayTaskTableRefreshed,
  setSearchData
} from "./autostorePutaway.slice";

export function AutostorePutawaySearch() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const trackedPageName = useMixpanelPageName();

  const isPutawayTaskTableRefreshed = useAppSelector(
    (state) => state.autostorePutaway.isPutawayTaskTableRefreshed
  );
  const onLeaveInputTextShown = useAppSelector(
    (state) => state.autostorePutaway.onLeaveInputTextShown
  );
  const searchData = useAppSelector(
    (state) => state.autostorePutaway.searchData
  );

  const setTextInput = (text: string) => {
    dispatch(selectRow(null));
    dispatch(
      setSearchData({
        offset: 1,
        scannedBarcodes: [],
        searchInputValue: text
      })
    );
  };

  const handleDebouncedSearch = (text: string | null) => {
    if (text) {
      mixpanelTrack({
        trackedPageName,
        type: "Search",
        label: "Search Product",
        eventProperties: {
          "Search Text": text
        }
      });
    }
    return "autocomplete";
  };

  const handleClearSearch = () => {
    mixpanelTrack({
      trackedPageName,
      type: "Button Click",
      label: "Clear Product Search"
    });
  };

  return (
    <Box
      id="autostorePutaway-navbar-searchComponent"
      display="flex"
      flexGrow="1"
      justifyContent="center"
    >
      <NavSearchInput
        textInput={searchData.searchInputValue || ""}
        setTextInput={setTextInput}
        isAutocomplete
        searchPlaceholder={t("search placeholder")}
        autocompleteSearchCb={handleDebouncedSearch}
        autocompleteOptions={[]}
        hideOptions
        onLeaveInputTextShown={onLeaveInputTextShown}
        isSearchRefreshed={isPutawayTaskTableRefreshed}
        isSearchRefreshedCallback={(isSearchRefreshed) =>
          dispatch(setIsPutawayTaskTableRefreshed(isSearchRefreshed))
        }
        autofocus={false}
        clearCb={handleClearSearch}
      />
    </Box>
  );
}
